import { render, staticRenderFns } from "./CoursewareToolbarContainers.vue?vue&type=template&id=4080f835&"
import script from "./CoursewareToolbarContainers.vue?vue&type=script&lang=js&"
export * from "./CoursewareToolbarContainers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports